import { useEffect, useRef } from "react";
import { List } from "react-virtualized";
import {
  GIF_MASONRY_FAKE_CELLS,
  GIF_MASONRY_GAPS,
  GIF_MASONRY_SKELETON_HEIGHTS,
} from "../../constants";
import type { IGifs } from "../../types";
import { GifsMasonryRow } from "./gifs-masonry-row";

const HEIGHTS = GIF_MASONRY_SKELETON_HEIGHTS;
const GAPS = GIF_MASONRY_GAPS;

interface IProps {
  scrollTop: number;
  colWidth: number;
  height: number;
  gifs: IGifs[];
  colIdx: number;
  onLoadMore?: () => void;
}

export const GifsMasonryColumn = ({
  gifs,
  scrollTop,
  colWidth,
  height,
  onLoadMore,
  colIdx,
}: IProps) => {
  const listRef = useRef<List | null>(null);

  useEffect(() => {
    if (!listRef.current) return;
    listRef.current.recomputeRowHeights();
  }, [colWidth, gifs]);

  return (
    <List
      ref={listRef}
      onRowsRendered={
        onLoadMore
          ? (data) => {
              if (
                data.startIndex >= gifs.length - GIF_MASONRY_FAKE_CELLS ||
                data.stopIndex >= gifs.length - GIF_MASONRY_FAKE_CELLS
              ) {
                onLoadMore();
              }
            }
          : undefined
      }
      autoHeight
      overscanRowCount={10}
      scrollTop={scrollTop}
      width={colWidth}
      height={height}
      rowCount={gifs.length + GIF_MASONRY_FAKE_CELLS}
      className="!tw-overflow-visible [&>div]:!tw-overflow-visible"
      rowHeight={({ index }) => {
        const data = gifs[index];
        if (!data) {
          return (
            HEIGHTS[colIdx % HEIGHTS.length][index % HEIGHTS.length] + GAPS
          );
        }
        const height = colWidth * (data.height / data.width) || 97;
        return height + GAPS;
      }}
      rowRenderer={(rowData) => (
        <GifsMasonryRow
          key={rowData.key}
          rowData={rowData}
          gifData={gifs[rowData.index]}
        />
      )}
    />
  );
};
